export const draftTitlesById = (drafts)=>new Map(drafts.map((draft)=>[
            draft.id,
            draft.title
        ]));
export const draftTitleOf = (titleById)=>(row)=>{
        const title = titleById.get(row.id);
        return title == null || title === '' ? undefined : [
            title
        ];
    };
export const createdDraftsMainColumn = (header, subtitle)=>({
        type: 'text',
        name: 'companyName',
        header,
        weight: 'normal',
        width: {
            initial: 240,
            min: 180
        },
        subtitle
    });
export const createdDraftsColumns = (modifiedBy, lastModified)=>[
        {
            type: 'text',
            name: 'modifiedBy',
            header: modifiedBy,
            width: {
                initial: 150,
                min: 120
            }
        },
        {
            type: 'text',
            name: 'lastModified',
            header: lastModified,
            width: {
                initial: 130,
                min: 110
            },
            skin: ()=>'secondary'
        }
    ];
